import { render } from "./ManuAccManage.vue?vue&type=template&id=07b12644&scoped=true"
import script from "./ManuAccManage.vue?vue&type=script&lang=js"
export * from "./ManuAccManage.vue?vue&type=script&lang=js"

import "./ManuAccManage.vue?vue&type=style&index=0&id=07b12644&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b12644"]])

export default __exports__